export default __webpack_public_path__ + "static/media/use-gamification-to-improve-ux.f736d9ee.png";